// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qp-1";
export var spinner = "_qp-0";